<template>
  <div class="weixin-login">
    <div class="qrcode-box">
      <Spin
        fix
        style="z-index: 999999;"
        v-if="!imageQrCode || loading">
        <Icon
          type="ios-loading"
          size="30"
          class="demo-spin-icon-load"></Icon>
      </Spin>
      <img
        v-else
        :src="'data:image/png;base64,' + imageQrCode"
        alt=""
        class="qrcode-img" />
      <div
        class="qrcode-refresh"
        v-if="isClose">
        <div class="qrcode-refresh-tips">
          二维码已过期，请<a @click="getWisdomPlatformQrcode">刷新</a>
        </div>
      </div>
    </div>
    <h4 class="qrcode-title">
      请使用微信扫描二维码登录
    </h4>
    <Alert
      type="warning"
      class="qrcode-title"
      style="margin-top: 12px;padding: 8px">
      <span style="margin-left: 2px;padding-top: 2px;">① </span>
      <span>绑定微信</span>
      <span style="margin-left: 2px;padding-top: 2px;">② </span>
      <span>扫码登录 </span>
      <span style="margin-left: 2px;padding-top: 2px;">③ </span>
      <span style="margin-right: 2px">小程序功能逐步增加中</span>
      <Poptip
        trigger="hover"
        word-wrap
        placement="bottom"
        width="500">
        <div slot="content">
          <span style="font-weight: 600;">智慧云平台微信小程序：</span>
          <span>是专为个人日常工作打造的移动端小程序，帮助个人在小程序上快速完成我的相关记录查看、我的学习等，减少APP下载安装更新烦恼，相关功能将逐步增加。</span>
        </div>
        <Icon
          type="md-information-circle"
          size="18"/>
      </Poptip>
    </Alert>
    <div
      class="qrcode-interrupt"
      v-if="visible === 1">
      <Alert
        type="warning"
        show-icon>
        小程序未登录，微信扫码登录流程中断！
      </Alert>
      <div class="qrcode-interrupt-content">
        请先登录智慧云平台小程序再重新扫码
      </div>
      <Button
        type="primary"
        class="qrcode-interrupt-btn"
        size="large"
        @click="ok">
        我已知晓
      </Button>
    </div>
    <div
      class="qrcode-interrupt"
      v-if="visible === 2">
      <div class="qrcode-interrupt-content">
        {{ message || '需在手机上完成登陆' }}
      </div>
      <Button
        type="primary"
        class="qrcode-interrupt-btn"
        size="large"
        @click="ok">
        取消
      </Button>
    </div>
  </div>
</template>
<script lang="jsx">
import {getWisdomPlatformQrcode} from '@/service/weixin-login.js';
import {setCookieInfo} from '@/util';
import Socket from '@/util/socket';
export default {
  lib: [['socket-io', {version: '1.7.4'}]],
  data() {
    return {
      imageQrCode: null,
      socket: null,
      isClose: false,
      timer: null,
      visible: false,
      loading: false,
      message: '',
    };
  },
  watch: {},
  computed: {},
  methods: {
    fetchSocketData(data) {
      this.$Message.success('登录成功');
      setCookieInfo('123cx@token', data.access_token, data.expires_in);
      setCookieInfo('login-time', new Date().getTime(), data.expires_in);
      this.$router.push(`/`);
    },
    destroySocket() {
      this.isClose = true;
      this.socket?.destroy();
      this.socket = null;
    },
    invalidQrcodeEvent(data) {
      if (data.event === 'wait_confirm_login') return this.visible = 2;
      else if (data.event === 'invalid_qrcode_event') this.visible = 1;
      else if (data.event === 'login_error') {
        this.visible = 2;
        this.message = data.message;
      }
      this.destroySocket();
    },
    ok() {
      this.visible = false;
      this.destroySocket();
      clearTimeout(this.timer);
      this.getWisdomPlatformQrcode();
    },
    initSocket(scene) {
      const dataIds = [scene];
      const eventAndHandleTupleList = [['login_websocket_event', this.fetchSocketData], ['scan_qrcode_event', this.invalidQrcodeEvent]];
      if (this.socket) return this.socket.refresh({dataIds, eventAndHandleTupleList});
      this.socket = new Socket({io: this['socketIo'], dataIds, eventAndHandleTupleList});
      this.timer = setTimeout(() => {
        this.destroySocket();
      }, 1000 * 60 * 3);
    },
    getWisdomPlatformQrcode() {
      this.imageQrCode = null;
      this.isClose = false;
      this.message = '';
      getWisdomPlatformQrcode({
        appId: 'wx9b8d93b7a7b1f768',
        businessType: 'webScanLogin',
        paramValue: JSON.stringify( {idx: '/webLoginPage', needAuth: true}),
        pageUrl: 'pages/index/index',
      }).then(({data}) => {
        this.imageQrCode = data.imageQrCode;
        this.socket?.destroy();
        this.initSocket(data.scene);
      });
    },
  },
  mounted() {
    this.getWisdomPlatformQrcode();
  },
  beforeDestroy() {
    this.destroySocket();
    clearTimeout(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.weixin-login{
  display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.qrcode-box {
  width: 210px;
  height: 210px;
  position: relative;
}
.qrcode-img {
  width: 100%;
  height: 100%;
}
.qrcode-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  text-wrap: nowrap;
  column-gap: 8px;
}

.qrcode-refresh{
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba($color: #000000, $alpha: 0.65);
  border-radius: 50%;

  .qrcode-refresh-tips{
    font-size: 16px;
    color: #fff;
  }
}

.qrcode-interrupt{
  position: absolute;
  top: 84px;
  left: 10px;
  right: 10px;
  bottom: 0;
  background-color: #fff;
  overflow: hidden;
  z-index: 99999;

  .qrcode-interrupt-content{
    background: #f7f7f7;
    border-radius: 4px;
    font-size: 18px;
    color: #111111;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 24px;
    margin: 24px 0;
    padding: 50px;
    text-align: center;
  }

  .qrcode-interrupt-btn{
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
  }
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

::v-deep{
  .ivu-spin-fix{
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    z-index: 8;
    width: auto;
    height: auto;
    background-color: hsla(0, 0%, 100%, .9);
  }
  .ivu-poptip-rel{
    top: 1px;
  }
}
</style>
